export const money = (v: any) => (typeof v === "number" ? v.toLocaleString("en-US", { style: "currency", currency: "USD" }) : v);

export const pct = (v: any) => (typeof v === "number" ? `${v}%` : v);